module.exports = /* @ngInject */
(
    $
) => {
    return {
        scrollToTop(element, offset) {
            $('html, body').animate({
                scrollTop: Math.round($(element).offset().top - offset)
            }, 500);
        }
    };
};
